import React, { useEffect, useState, useRef, createRef } from "react";
import Topbar from "../Components/Structure/Topbar";
import { Grid, Typography, TextField } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import moment from "moment";
import {
  cancelCallApi,
  getActiveCallsApi,
  remakeCallApi,
} from "../Apis/Endpoints/DashboardApi";
import { useSelector, useDispatch } from "react-redux";
import AlertApiResult from "../Components/Structure/AlertApiResult";
import NotFound from "../Components/Structure/NotFound";
import ActiveCallsTable from "../Components/Tables/ActiveCallsTable";
import BackButton from "../Components/Structure/BackButton";
import { useTranslation } from "react-i18next";

function ActiveCalls() {
  // 1) Data
  const ApplicationSettings = useSelector(
    (state) => state.ApplicationSettings.value
  );
  const { t } = useTranslation();
  const LoginSettings = useSelector((state) => state.LoginSettings.value);
  const Account = useSelector((state) => state.Account.value);
  const [errorMessage, seterrorMessage] = useState("Error");
  const [showError, setshowError] = useState(false);
  const [callApiStatus, setcallApiStatus] = useState("");
  const [callsDataArray, setcallsDataArray] = useState([]);
  const [loading, setloading] = useState(false);

  // 2) useEffects
  useEffect(() => {
    //on First Load
    getActiveCalls();

    const intervalId = setInterval(() => {
      getActiveCalls();
      // console.log("Render getActiveCalls");
    }, ApplicationSettings.Refresh_Calls_Seconds * 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    let key = "";
    if (ApplicationSettings.Use_Custom_Map_Key) {
      key = ApplicationSettings.Map_Key;
    } else {
      key = Account.google_key;
    }

    let url =
      "https://maps.googleapis.com/maps/api/js?key=" +
      key +
      "&callback=Function.prototype";

    let exist = isMyScriptLoaded(url);

    if (!exist) {
      var head = document.getElementsByTagName("head")[0];
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://maps.googleapis.com/maps/api/js?key=" +
        key +
        "&callback=Function.prototype";
      head.appendChild(script);
    }

    return;
  }, []);

  // 3) Functions
  const getActiveCalls = async () => {
    let start = moment().subtract(1, "M").unix();
    let end = moment().unix();

    let calls = [];

    try {
      const response = await getActiveCallsApi(
        LoginSettings.web_server_url,
        start,
        end,
        Account.token
      );

      let responseObject = response.data.result;
      if (responseObject.resultCode === 0) {
        calls = response.data.response.calls;

        //console.log("RESPONSE CALLS :", calls);

        let x = Account.geoX;
        let y = Account.geoY;

        const promises = [];
        calls.forEach((obj) => {
          if (obj.info.callStatus === 10) {
            const { lastLatitude, lastLongitude } = obj;
            const promise = fetchDistanceMatrix(
              lastLatitude,
              lastLongitude,
              y,
              x
            ).then(({ distance, duration }) => {
              obj.distance = distance;
              obj.duration = duration;
            });
            promises.push(promise);
          }
        });

        await Promise.all(promises);
        //console.log("Promises :", calls);
        setcallsDataArray(calls);
        setloading(false);
      } else {
        console.log("Error while trying to get calls");
      }
    } catch (error) {
      console.error("Error while fetching active calls:", error);

      const response = await getActiveCallsApi(
        LoginSettings.web_server_url,
        start,
        end,
        Account.token
      );
      let responseObject = response.data.result;
      if (responseObject.resultCode === 0) {
        calls = response.data.response.calls;
        setcallsDataArray(calls);
      }
    }
  };

  const cancelCall = async (callObject) => {
    console.log("Cancel Call Called with : ", callObject);

    let request_object = {
      callId: callObject.info.callID,
      driverID: callObject.info.driverId,
    };

    cancelCallApi(LoginSettings.web_server_url, request_object, Account.token)
      .then((response) => {
        if (response.status === 200) {
          console.log("Response send ok with : ", response.data);
          setcallApiStatus("Success");
          seterrorMessage("Call has been canceled.");
          setshowError(true);
          setTimeout(getActiveCalls, 1000);
        } else {
          console.log("ERROR OCCUURED");
        }
      })
      .catch((error) => {})
      .finally(() => {
        setloading(false);
      });
  };

  const remakeCall = async (callObject) => {
    console.log("Remake Call Called with : ", callObject);

    let request_object = {
      callerPhone: "000",
      roadName: callObject.pickupAddress,
      //municipality: "",
      longitude: callObject.pickupLng,
      latitude: callObject.pickupLat,
      taxisNo: 1,
      destination: callObject.destination,
      customerName: callObject.customerName,
      dev: "WEB BUTTON",
      callId: callObject.callID,
    };

    remakeCallApi(LoginSettings.web_server_url, request_object, Account.token)
      .then((response) => {
        if (response.status === 200) {
          console.log("Response send ok with : ", response.data);
          setcallApiStatus("Success");
          seterrorMessage("Call has been canceled.");
          setshowError(true);
          setTimeout(getActiveCalls, 1000);
        } else {
          console.log("ERROR OCCUURED");
        }
      })
      .catch((error) => {})
      .finally(() => {
        setloading(false);
      });
  };

  const fetchDistanceMatrix = (originLat, originLng, destLat, destLng) => {
    return new Promise((resolve, reject) => {
      const service = new window.google.maps.DistanceMatrixService();
      const origin = new window.google.maps.LatLng(originLat, originLng);
      const destination = new window.google.maps.LatLng(destLat, destLng);

      console.log("Google Api is called now...");

      service.getDistanceMatrix(
        {
          origins: [origin],
          destinations: [destination],
          travelMode: "DRIVING",
        },
        (response, status) => {
          if (status === "OK" && response.rows.length > 0) {
            const distance = response.rows[0].elements[0].distance.text;
            const duration = response.rows[0].elements[0].duration.text;

            resolve({ distance, duration });
          } else {
            reject(new Error("Unable to fetch distance matrix"));
          }
        }
      );
    });
  };

  function isMyScriptLoaded(url) {
    var scripts = document.getElementsByTagName("script");
    for (var i = scripts.length; i--; ) {
      if (scripts[i].src == url) return true;
    }
    return false;
  }

  return (
    <>
      {showError && (
        <AlertApiResult
          message={errorMessage}
          status={callApiStatus}
          setClose={setshowError}
        />
      )}
      <Topbar page="Active Calls" />

      {/* Header */}
      <div className="text-center mt-3">
        <p className=" text-3xl  Primary_Main_Text">{t("ΕΝΕΡΓΕΣ_ΚΛΗΣΕΙΣ")}</p>
      </div>

      {/* Datatable */}
      <div className=" max-w-3xl m-auto px-3 pt-3 pb-10 mb-1">
        {callsDataArray.length > 0 ? (
          <>
            <ActiveCallsTable
              data={callsDataArray}
              cancelCall={cancelCall}
              remakeCall={remakeCall}
            />
          </>
        ) : (
          <NotFound text={t("Unfortunately,no_data_found_with_given_dates.")} />
        )}
      </div>

      {/* Back Button */}
      <div className="block sm:hidden">
        <BackButton />
      </div>
    </>
  );
}

export default ActiveCalls;
